/**
 * A small count pill on a filter tab / chip (matches the category-picker count badges). `bg-foreground/10` is
 * theme-aware and reads on both the ghost (inactive) and secondary (active) tab backgrounds, in light + dark.
 *
 * On a **primary** chip (a `Button variant="default"` — the drill-down's SELECTED filter chip, which is the tenant BRAND
 * fill), the muted grey number is nearly invisible on the brand colour. So `in-data-[variant=default]:*` (the Button sets
 * `data-variant`) darkens the pill and flips the number to the primary INK — white on Takeda's red, readable in BOTH
 * themes. Every other selected chip uses the `secondary` variant, where the default treatment already reads.
 *
 * Shared by the facility filter tabs ({@link FacilitySelection}) and the manuals-view category chips
 * ({@link FacilityManualsView}) so the count treatment is identical everywhere.
 */
export function CountPill({ n }: { n: number }) {
  return (
    // aria-hidden: a scannability aid, not part of the tab's accessible name — the label ("Archived", a category name…)
    // already names the control, and its contents convey the count to SR users on activation.
    <span
      aria-hidden="true"
      className="bg-foreground/10 text-muted-foreground in-data-[variant=default]:bg-black/20 in-data-[variant=default]:text-primary-foreground ml-0.5 inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-[0.7rem] leading-none tabular-nums"
    >
      {n}
    </span>
  );
}
